export default __webpack_public_path__ + "images/fyta_logo.png";